import { useContext } from "react";

import { DeebContext } from "../context/Deed/DeedContext";

export const useDeedContext = () => {
  return useContext(DeebContext);
};
